import React, { useState, useEffect, useRef } from "react";
import { _makeId } from "../utils/helper"

const Radio = ({
  label,
  name,
  value,
  onChange,
  onFocus,
  onBlur,
  checked,
  ...props
}) => {
  const id = _makeId(5);

  return (
    <div className="tema-radio">
      <input
        type="radio"
        name={name}
        value={value}
        onChange={(e) => onChange(e.target.checked, value)}
        onFocus={onFocus}
        onBlur={onBlur}
        id={id}
        checked={checked}
      />
      <label htmlFor={id}></label>
      <label htmlFor={id} className="whitespace-nowrap">{label}</label>
    </div>
  );
};

export default Radio;
